import { ACCOUNT, TRANSACTIONS } from '@/constants';

export const labels = {
  [ACCOUNT.TRANSACTION_TYPES.CW20_RECEIVED]: 'Token CW20 ricevuti',
  [ACCOUNT.TRANSACTION_TYPES.CW20_SENT]: 'Token CW20 inviati',
  [ACCOUNT.TRANSACTION_TYPES.RECEIVED]: 'Ricevute',
  [ACCOUNT.TRANSACTION_TYPES.SENT]: 'Inviate',
  [TRANSACTIONS.MULTI_FEE]: 'Più fee',
  [TRANSACTIONS.MULTI_TYPE]: 'Più tipi',
  abrAndVbrRewardsNotDistributed: 'ABR e VBR compensi non distribuiti',
  abrTokensDistributed: 'Token ABR distribuiti',
  abrTokensNotDistributed: 'Token ABR non distribuiti',
  abstain: 'Astenuto',
  active: 'Attivo',
  address: 'Indirizzo',
  admin: 'Amministratore',
  algorithm: 'Algoritmo',
  amount: 'Importo',
  assertionMethod: 'Assertion method',
  authentication: 'Authentication',
  available: 'Disponibile',
  availables: 'Disponibili',
  balance: 'Saldo',
  blocks: 'Blocchi',
  blocksPercentage: '% Blocchi',
  bonded: 'Vincolati',
  bondedTokens: 'Token vincolati',
  burned: 'Bruciati',
  buyer: 'Acquirente',
  cap: 'Cap',
  capabilityDelegation: 'Capability delegation',
  capabilityInvocation: 'Capability invocation',
  caption: 'Didascalia',
  certificateProfile: 'Profilo del certificato',
  chain: 'Chain',
  changes: 'Modifiche',
  circulatingSupply: 'Supply circolante',
  claimRewards: 'Richiedi rewards',
  codeId: 'Code Id',
  venAmount: 'Importo in {symbol}',
  venTotal: 'Totale {symbol}',
  commission: 'Commissione',
  communityTokensDistributed: 'Token Community distribuiti',
  communityTokensNotDistributed: 'Token Community non distribuiti',
  completionDate: 'Data di completamento',
  confirm: 'Conferma',
  connectWallet: 'Connetti wallet',
  content: 'Contenuto',
  contentUri: 'URI contenuto',
  context: 'Contesto',
  contract: 'Contratto',
  contractAddress: 'Indirizzo contratto',
  controller: 'Controller',
  created: 'Creato',
  cumulative: 'Cumulativo',
  date: 'Data',
  days: 'Giorni',
  decimals: 'Decimali',
  delegated: 'Delegati',
  delegatedTokens: 'Token delegati',
  delegations: 'Delegazioni',
  delegator: 'Delegatore',
  delegatorAddress: 'Indirizzo delegatore',
  denom: 'Denominazione',
  deposit: 'Deposito',
  depositEndTime: 'Orario fine deposito',
  depositor: 'Depositante',
  description: 'Descrizione',
  destinationValidatorAddress: 'Indirizzo validatore destinatario',
  detail: 'Dettagli',
  did: 'Did',
  documentUUID: 'UUID documento',
  earning: 'Guadagnando',
  editVote: 'Modifica voto',
  encryptionDataEncryptedData: 'Dati criptati dei dati criptati',
  encryptionDataKeys: 'Chiavi dei dati criptati',
  exchangeRate: 'Tasso di cambio',
  expectedAmount: 'Importo atteso',
  failed: 'Fallito',
  fee: 'Commissione',
  filter: 'Filtro',
  freezePeriod: 'Periodo di congelamento',
  freezed: 'Congelati',
  freezedTokens: 'Token congelati',
  fromAddress: 'Da indirizzo',
  fromToken: 'Da token',
  funds: 'Fondi',
  gasUsedWanted: 'Gas (Usato/Richiesto)',
  getOnline: 'Vai online',
  government: 'Governo',
  hash: 'Hash',
  height: 'Altezza',
  hours: 'Ore',
  id: 'id',
  identity: 'Identità',
  inactive: 'Inattivo',
  info: 'Info',
  instantiateContract: 'Instanzia contratto',
  instantiatePermission: 'Instanziare autorizzazione',
  key: 'Chiave',
  keyAgreement: 'Accordo chiave',
  label: 'Etichetta',
  lang: 'Lingua',
  lastUpdate: 'Ultimo aggiornamento: {0}',
  lbrTokensDistributed: 'Token LBR distribuiti',
  lbrTokensNotDistributed: 'Token LBR non distribuiti',
  liquidityPoolTokensDistributed: 'Token Liquidity Pool distribuiti',
  liquidityPoolTokensNotDistributed: 'Token Liquidity Pool non distribuiti',
  logo: 'Logo',
  logoUrl: 'Logo URL',
  manage: 'Gestisci',
  marketing: 'Marketing',
  max: 'Max',
  maxChangeRate: 'Max tasso di cambio',
  maxRate: 'Max tasso',
  maxSupply: 'Max supply',
  memo: 'Memo',
  metadataContentUri: 'URI contenuto metadata',
  metadataSchemaType: 'Tipo schema metadata',
  metadataSchemaUri: 'URI schema metadata',
  metadataSchemaVersion: 'Versione schema metadata',
  minSelfDelegation: 'Min auto delegazione',
  minter: 'Minter',
  minutes: 'Minuti',
  moniker: 'Moniker',
  moreInfo: 'Più info',
  msg: 'Messaggio',
  msgType: 'Tipo messaggio',
  msgs: 'Msgs',
  msgsOnTxs: 'Msgs/Txs',
  multiTypes: 'Più tipi',
  multiValues: 'Più valori',
  myValidators: 'Miei validatori',
  name: 'Nome',
  no: 'No',
  noWithVeto: 'No con veto',
  nonCirculatingSupply: 'Supply non circolante',
  none: 'Nessuno',
  not: 'Non',
  notBonded: 'Non vincolati',
  notEarning: 'Non guadagnando',
  officialNode: 'Nodo ufficiale (raw json)',
  operator: 'Operatore',
  others: 'Altri',
  percentage: 'Percentuale',
  plan: 'Piano',
  project: 'Progetto',
  proof: 'Prova',
  proofPurpose: 'Scopo della prova',
  proposer: 'Proponente',
  publicKey: 'Chiave pubblica',
  publicKeyMultibase: 'PublicKey Multibase',
  publicKeyPem: 'Chiave pubblica pem',
  quantity: 'Quantità',
  rank: 'Rank',
  rate: 'Tasso',
  rawLog: 'Raw log',
  received: 'Ricevute',
  receivedTxs: 'Transazioni ricevute',
  nativeReceived: 'Nativi ricevuti',
  nativeReceivedTxs: 'Token nativi ricevuti',
  cw20Received: 'CW20 ricevuti',
  cw20ReceivedTxs: 'Token CW20 ricevuti',
  receiver: 'Ricevente',
  recipient: 'Destinatario',
  redelegable: 'Redelegabile',
  redelegateFrom: 'Redelega da',
  refresh: 'Aggiornare',
  reserve: 'Riserva',
  reset: 'Azzera',
  result: 'Risultato',
  reverse: 'Inverti',
  revisionHeight: 'Height revisione',
  revisionNumber: 'Numero revisione',
  rewards: 'Compensi',
  save: 'Salva',
  sdnData: 'Dati SDN',
  search: 'Cerca',
  searchHeight: 'Cerca altezza',
  searchNameAddressAccount: 'Cerca nome, indirizzo, account',
  seconds: 'Secondi',
  securityContact: 'Contatto sicurezza',
  select: 'Seleziona',
  selectDex: 'Seleziona un DEX',
  self: 'Self',
  send: 'Invia',
  sender: 'Mittente',
  sent: 'Inviate',
  sentTxs: 'Transazioni inviate',
  service: 'service',
  serviceEndpoint: 'Endpoint del servizio',
  share: 'Condividere',
  showAll: 'Mostra tutti',
  signatureValue: 'Valore della firma',
  signer: 'Firmatario',
  signerInstance: 'Istanza del firmatario',
  sourceChannel: 'Source channel',
  sourcePort: 'Source port',
  sourceValidatorAddress: 'Indirizzo validatore di origine',
  status: 'Stato',
  storageUri: 'URI archivio',
  submitTime: 'Orario presentazione',
  subscriber: 'Sottoscrittore',
  subspace: 'Sottospazio',
  subtotal: 'Subtotale',
  success: 'Successo',
  supply: 'Supply',
  swap: 'Swap',
  symbol: 'Simbolo',
  time: 'Orario',
  timeoutTimestamp: 'Timeout timestamp',
  title: 'Titolo',
  toAddress: 'Ad indirizzo',
  toToken: 'A token',
  token1: 'Token1',
  token2: 'Token2',
  tokens: 'Token',
  tokensPerformance: 'Performance dei token',
  total: 'Totale',
  totalCirculatingSupply: 'Totale di supply circolante',
  totalNonCirculatingSupply: 'Totale di supply non circolante',
  transfer: 'Trasferisci',
  tsp: 'Tsp',
  turnout: 'Affluenza',
  txHash: 'Tx hash',
  txs: 'Txs',
  txsAmount: 'Quantità di txs',
  type: 'Tipo',
  udetails: 'Udetails',
  unbondings: 'Unbondings',
  unclaimedRewards: 'Compensi non reclamati',
  unreleasedRewards: 'Compensi non rilasciati',
  updateTime: 'Orario di aggiornamento',
  upgradedClientState: 'Stato cliente aggiornato',
  urlLogo: 'URL logo',
  uuid: 'UUID',
  validator: 'Validatore',
  validatorAddress: 'Indirizzo validatore',
  validatorTokensDistributed: 'Token validatore distribuiti',
  validatorTokensNotDistributed: 'Token validatore non distribuiti',
  validators: 'Validatori',
  value: 'Valore',
  vbrTokensDistributed: 'Token VBR distribuiti',
  vbrTokensNotDistributed: 'Token VBR non distribuiti',
  vcrId: 'VCR id',
  verificationMethod: 'Metodo di verifica',
  verifyHash: 'Verifica hash',
  vote: 'Voto',
  voter: 'Votante',
  votingEndTime: 'Ora fine voto',
  votingPower: 'Potere voto',
  votingStartTime: 'Ora inizio voto',
  wallet: 'Wallet',
  wasmByteCode: 'Wasm bytecode',
  website: 'Sito Web',
  withdraw: 'Prelievo',
  yes: 'Si',
};
